import { axios } from '@/utils/request'

const api = {
  workflow: '/workflow/process',
  model: '/workflow/model',
  instance: '/workflow/instance',
  historyInstance: '/workflow/history-instance',
  todo: '/workflow/todo',
  leave: '/workflow/leave',
  basicData: '/basicdata/notices',
  statusNum: '/stuff/statusNum'
}

export function getLine(parameter) {
  return axios({
    url: '/stuff/stuff/getEchterpriseOrderLineChart',
    method: 'get',
    params: parameter,
  })
}
export function getOrderTypeWeightNum(parameter) {
  return axios({
    url: api.statusNum + '/getOrderTypeWeightNum1',
    method: 'get',
    params: parameter,
  })
}
export function getSpcialTypeWeightNum(parameter) {
  return axios({
    url: api.statusNum + '/getSpcialTypeWeightNum1',
    method: 'get',
    params: parameter,
  })
}

//人员数据
export function getAllIcon(parameter) {
  return axios({
    url: api.statusNum + '/getAllIcon',
    method: 'get',
    params: parameter,
  })
}

// 排序
export function updateWeight(parameter) {
  return axios({
    url: '/stuff/order/updateWeight',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

// 通知公告
export function basicData(parameter) {
  return axios({
    url: api.basicData + '/noticeList',
    method: 'get',
    params: parameter
  })
}

// 公告详情
export function getOrderTypeList(parameter) {
  return axios({
    url: api.basicData + `/get/${parameter}`,
    method: 'get',
  })
}
// 首页跳转详情
export function orderLink(parameter) {
  return axios({
    url: '/stuff/link/orderLink',
    method: 'get',
    params: parameter
  })
}

export function getTPbApartmentEmployee48List(parameter) {
  return axios({
    url: '/stuff/stuff/list',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function getxiangqingInfo(parameter) {
  return axios({
    url: '/stuff/stuff/stuffinfo',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// 企业top10
export function topTenOfEnterprise(parameter) {
  return axios({
    url: '/stuff/stuff/toptenofenterprise',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// 客服超时单查询
export function getOverTime(parameter) {
  return axios({
    url: '/stuff/stuff/overtimeorder',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// 冻结单查询
export function getForzenTime(parameter) {
  return axios({
    url: '/stuff/stuff/freezeorder',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

// 值班技术
export function supportWorkNo(parameter) {
  return axios({
    url: '/stuff/stuff/supportworkno',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}



// export default api

export function getProcessList(parameter) {
  return axios({
    url: api.workflow + '/list',
    method: 'get',
    params: parameter
  })
}
export function saveProcess(parameter) {
  return axios({
    url: api.workflow + (parameter.id > 0 ? '/update' : '/save'),
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
export function delProcess(parameter) {
  return axios({
    url: api.workflow + '/remove',
    method: 'post',
    params: parameter
  })
}
export function getModelList(parameter) {
  return axios({
    url: api.model + '/list',
    method: 'get',
    params: parameter
  })
}

export function deployModel(parameter) {
  return axios({
    url: api.model + '/deploy',
    method: 'post',
    params: parameter
  })
}

export function delModel(parameter) {
  return axios({
    url: api.model + '/remove',
    method: 'post',
    params: parameter
  })
}

export const genBPMNUrl = api.model + '/export'

export function getInstanceList(parameter) {
  return axios({
    url: api.instance + '/list',
    method: 'get',
    params: parameter
  })
}

export function detailInstance(parameter) {
  return axios({
    url: api.instance + '/detail',
    method: 'post',
    params: parameter
  })
}

export function delInstance(parameter) {
  return axios({
    url: api.instance + '/remove',
    method: 'post',
    params: parameter
  })
}

export function getHistoryInstanceList(parameter) {
  return axios({
    url: api.historyInstance + '/list',
    method: 'get',
    params: parameter
  })
}

export function detailHistoryInstance(parameter) {
  return axios({
    url: api.historyInstance + '/detail',
    method: 'post',
    params: parameter
  })
}

export function delHistoryInstance(parameter) {
  return axios({
    url: api.historyInstance + '/remove',
    method: 'post',
    params: parameter
  })
}

export function getMyTodoInstanceList(parameter) {
  return axios({
    url: api.todo + '/list',
    method: 'get',
    params: parameter
  })
}

export function getLeaveList(parameter) {
  return axios({
    url: api.leave + '/list',
    method: 'get',
    params: parameter
  })
}

export function applyLeave(parameter) {
  return axios({
    url: api.leave + (parameter.id > 0 ? '/update' : '/save'),
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function delLeave(parameter) {
  return axios({
    url: api.leave + '/remove',
    method: 'post',
    params: parameter
  })
}
